import { render } from "./index.vue?vue&type=template&id=b447dc4a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b447dc4a&scoped=true&lang=less"
import "./index.vue?vue&type=style&index=1&id=b447dc4a&scoped=true&lang=less"

import exportComponent from "E:\\project\\zjam-ctid\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b447dc4a"]])

export default __exports__